import { render } from "./NewRegister.vue?vue&type=template&id=1061e6d6&scoped=true"
import script from "./NewRegister.vue?vue&type=script&lang=js"
export * from "./NewRegister.vue?vue&type=script&lang=js"

import "./NewRegister.vue?vue&type=style&index=0&id=1061e6d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1061e6d6"]])

export default __exports__